<template>
  <v-select
    v-model="select"
    :items="items"
    @change="setSelectResult"
    prepend-icon="mdi-list-status"
    item-text="text"
    item-value="result"
    :label="$t('result')"
    dense
    filled
    hide-details
    solo-inverted
  ></v-select>
</template>
<script>
export default {
  name: "components-common-filters-select-result-bet",
  data: () => ({
    level: null,
    items: [],
    select: "",
  }),
  watch: {
    $route(val) {
      // Pra evitar inconsistências com os status que existem em uma view e não em outra, é melhor sempre resetar o status pra um que todas as views tem
      this.setSelectResult(3);
      this.select = { text: this.$t("pendings"), result: 3 };

      const route = val.name;

      if (
        route === "AdministratorAccountabilityOnlinePlayersOnlineSearch" ||
        route === "AdministratorBetListPlayerOnline" ||
        route === "CollaboratorBetListPlayerOnline"
      ) {
        this.items = [
          { text: this.$t("pendings"), result: 3 },
          { text: this.$t("losts"), result: 0 },
          { text: this.$t("awarded"), result: 1 },
          { text: this.$t("finishedBetPlural"), result: 4 },
        ];
        return;
      }

      if (route === "AdministratorBetListOnline") {
        this.items = [
          { text: this.$t("pendings"), result: 3 },
          { text: this.$t("losts"), result: 0 },
          { text: this.$t("awarded"), result: 1 },
        ];
        return;
      }

      var level = localStorage.getItem("level");
      if (level == "administrator") {
        if (route == "AdministratorBetList") {
          this.items = [
            { text: this.$t("pendings"), result: 3 },
            { text: this.$t("losts"), result: 0 },
            { text: this.$t("awarded"), result: 1 },
          ];
        } else if (route == "AdministratorAgentBetList") {
          this.items = [
            { text: this.$t("pendings"), result: 3 },
            { text: this.$t("losts"), result: 0 },
            { text: this.$t("awarded"), result: 1 },
            { text: this.$t("all"), result: 4 },
          ];
        } else if (route === "AdministratorUsersPlayersSearch") {
          this.items = [
            { text: this.$t("pendings"), result: 3 },
            { text: this.$t("losts"), result: 0 },
            { text: this.$t("awarded"), result: 1 },
          ];
        }
      }
      if (level == "regionalManager") {
        this.items = [
          { text: this.$t("pendings"), result: 3 },
          { text: this.$t("losts"), result: 0 },
          { text: this.$t("awarded"), result: 1 },
          // { text: this.$t("finishedBetPlural"), result: 4 },
        ];
      }
    },
  },
  async mounted() {
    this.select = { text: this.$t("pendings"), result: 3 };
    // SETUP:
    // =========================================================== ]]
    // IF - LOCAL MANAGER
    // No nível de gerente Local, não existe o uso do item "Todas, 4".
    // Pórem, existe o item "Premiadas não pagas, 2",
    // se ele estiver autorizado.
    this.level = localStorage.getItem("level");
    if (this.level === "localManager") {
      const response = await this.$request.get(
        "/localManager/profile/permissions"
      );
      var authorized = response.dados.reward_bet;

      // Incrementa um item ao final de um array ("Premiadas não pagas", 2);
      if (authorized == 1) {
        this.items = [
          { text: this.$t("pendings"), result: 3 },
          { text: this.$t("losts"), result: 0 },
          { text: this.$t("awarded"), result: 1 },
          { text: this.$t("unpaidAwards"), result: 2 },
          // { text: this.$t("finishedBetPlural"), result: 4 },
        ];
      } else {
        this.items = [
          { text: this.$t("pendings"), result: 3 },
          { text: this.$t("losts"), result: 0 },
          { text: this.$t("awarded"), result: 1 },
          // { text: this.$t("unpaidAwards"), result: 2 },
          // { text: this.$t("finishedBetPlural"), result: 4 },
        ];
      }
    }

    // Evita que a motagem do filtro quebre quando der F5 na view de Apostas Online, Apostas PDV e Apostas (Jogadores - Rede)
    if (
      this.$route.name == "AdministratorBetListPlayerOnline" ||
      this.$route.name ==
        "AdministratorAccountabilityOnlinePlayersOnlineSearch" ||
      this.$route.name == "CollaboratorBetListPlayerOnline"
    ) {
      this.items = [
        { text: this.$t("pendings"), result: 3 },
        { text: this.$t("losts"), result: 0 },
        { text: this.$t("awarded"), result: 1 },
        { text: this.$t("finishedBetPlural"), result: 4 },
      ];
    }
    // Apostas PDV ou Apostas (Rede - credit 1)
    if (
      this.$route.name == "AdministratorBetList" ||
      this.$route.name == "AdministratorBetListOnline"
    ) {
      this.items = [
        { text: this.$t("pendings"), result: 3 },
        { text: this.$t("losts"), result: 0 },
        { text: this.$t("awarded"), result: 1 },
      ];
    }
    // Jogadores (Rede) Apostas
    if (this.$route.name == "AdministratorUsersPlayersSearch") {
      this.items = [
        { text: this.$t("pendings"), result: 3 },
        { text: this.$t("losts"), result: 0 },
        { text: this.$t("awarded"), result: 1 },
      ];
    }
  },
  methods: {
    setSelectResult(result) {
      this.$store.commit("setSelectResultBet", result);
    },
  },
};
</script>
